var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 16.5C1.35938 16.5 0.917969 16.3259 0.550781 15.9778C0.183594 15.6296 0 15.2111 0 14.7222V2.27778C0 1.78889 0.183594 1.37037 0.550781 1.02222C0.917969 0.674074 1.35938 0.5 1.875 0.5H15C15.5156 0.5 15.957 0.674074 16.3242 1.02222C16.6914 1.37037 16.875 1.78889 16.875 2.27778V14.7222C16.875 15.2111 16.6914 15.6296 16.3242 15.9778C15.957 16.3259 15.5156 16.5 15 16.5H1.875ZM2.8125 12.9444H14.0625L10.5469 8.5L7.73438 12.0556L5.625 9.38889L2.8125 12.9444ZM5.15625 6.72222C5.54688 6.72222 5.87891 6.59259 6.15234 6.33333C6.42578 6.07407 6.5625 5.75926 6.5625 5.38889C6.5625 5.01852 6.42578 4.7037 6.15234 4.44444C5.87891 4.18519 5.54688 4.05556 5.15625 4.05556C4.76562 4.05556 4.43359 4.18519 4.16016 4.44444C3.88672 4.7037 3.75 5.01852 3.75 5.38889C3.75 5.75926 3.88672 6.07407 4.16016 6.33333C4.43359 6.59259 4.76562 6.72222 5.15625 6.72222Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.0ab0af98c4eceecb5b87a7041c1d197f.svg";
export { ForwardRef as ReactComponent };